// extracted by css-extract-rspack-plugin
export default {"wrapper":"TimeTrackingMask_wrapper__A5O2B"};